import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import { CardTrackingStatus } from '../../../../types';
import styles from './StatusWizard.module.css';
const statusOrder = [
    CardTrackingStatus.CREATED,
    CardTrackingStatus.DISPATCHED,
    CardTrackingStatus.IN_TRANSIT,
    CardTrackingStatus.OUT_FOR_DELIVERY,
    CardTrackingStatus.DELIVERED,
];
const icons = ['wizardCard', 'wizardPaperPlane', 'wizardTruck', 'wizardDeliveryTruck', 'wizardPersonWithBox'];
const mapCurrentStatus = (currentStatus) => {
    switch (currentStatus) {
        case CardTrackingStatus.OUT_FOR_DELIVERY:
        case CardTrackingStatus.DELIVERY_FAILED:
        case CardTrackingStatus.CANCELLED:
        case CardTrackingStatus.DELIVERY_ISSUE_UNDER_INVESTIGATION:
            return CardTrackingStatus.OUT_FOR_DELIVERY;
        case CardTrackingStatus.CREATED:
        case CardTrackingStatus.DISPATCHED:
        case CardTrackingStatus.IN_TRANSIT:
        case CardTrackingStatus.DELIVERED:
            return currentStatus;
        default:
            return CardTrackingStatus.CREATED;
    }
};
const resolveWizardStepStatus = (isCompleted, isCurrent) => {
    if (isCompleted) {
        return 'completed';
    }
    if (isCurrent) {
        return 'current';
    }
    return 'pending';
};
export function StatusWizard({ currentStatus }) {
    const { t } = useTranslation();
    const mappedStatus = mapCurrentStatus(currentStatus);
    const currentIndex = statusOrder.indexOf(mappedStatus);
    return (_jsx("section", { className: styles.statusWizardSection, "data-testid": 'viewStatusWizardSection', children: statusOrder.map((status, stepIndex) => {
            const isCompleted = stepIndex < currentIndex || mappedStatus === CardTrackingStatus.DELIVERED;
            const stepStatus = resolveWizardStepStatus(isCompleted, stepIndex === currentIndex);
            const stepIcon = stepStatus === 'pending' ? `${icons[stepIndex]}Inactive` : icons[stepIndex];
            const isLastCompleted = stepStatus === 'completed' && stepIndex === currentIndex - 1 && mappedStatus !== CardTrackingStatus.DELIVERED;
            return (_jsxs("div", { className: `
              ${styles.wizardStep} ${styles[`step${stepStatus.charAt(0).toUpperCase() + stepStatus.slice(1)}`]}
              ${isLastCompleted ? styles.lastCompleted : ''}
              ${stepIndex === 0 && stepStatus === 'current' ? styles.isCurrentFirstStep : ''}
            `, "data-testid": `viewStatusWizardStep${stepIndex}`, children: [_jsx("div", { className: styles.stepIcon, "data-testid": `viewStatusWizardStepIcon${stepIndex}`, children: _jsx(Icon, { name: stepIcon, "data-testid": `iconStatusWizardStepIcon${stepIndex}` }) }), _jsx("div", { className: styles.stepIndicator, "data-testid": `viewStatusWizardStepIndicator${stepIndex}`, children: stepStatus === 'completed' ? (_jsx(Icon, { name: 'checkMark', "data-testid": `iconStatusWizardStepCheckMark${stepIndex}` })) : (_jsx("span", { className: styles.stepNumber, "data-testid": `textViewStatusWizardStepNumber${stepIndex}`, children: stepIndex + 1 })) }), _jsx("div", { className: styles.stepLabel, "data-testid": `textViewStatusWizardStepLabel${stepIndex}`, children: t(`cards.tracking.status.${status}`) }), stepIndex < statusOrder.length - 1 && (_jsx("div", { className: styles.stepConnector, "data-testid": `viewStatusWizardStepConnector${stepIndex}` }))] }, status));
        }) }));
}
